<template>
  <div class="common-progress-bar">
    <p>{{ percentage }}%</p>
    <div class="progress-bar-wrapper">
      <div class="gauge" :style="{ width: percentage + '%' }"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    percentage?: number
  }>(),
  {}
)
</script>

<style scoped>
.common-progress-bar {
  display: flex;
  align-items: center;
  gap: 5px;
  max-width: 250px;
  width: 100%;
}

.common-progress-bar > p {
  color: var(--vc-success);
}
.progress-bar-wrapper {
  width: 100%;
  background-color: var(--vc-light);
  height: 6px;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar-wrapper > div {
  background-color: var(--vc-success);
  height: 6px;
  border-radius: 10px;
}
</style>
